import { Card, Text } from '@mantine/core';
import { Debit } from 'interfaces';
import { formatDateOnly } from 'utils/dateUtils';
import { calculateNetAmount, calculateOverheadFee } from 'utils/overheadUtils';

interface DebitCardProps {
  debit: Debit;
}

export const DebitCard: React.FC<DebitCardProps> = ({ debit }) => {
  const overhead = Number(debit.claim?.overhead ?? 0);

  return (
    <Card shadow="sm" radius="md" withBorder>
      <InfoRow label="Date:" value={formatDateOnly(debit.createdAt)} />
      <InfoRow
        label="Provider:"
        value={`${debit?.provider?.firstName} ${debit?.provider?.lastName}`}
      />
      <InfoRow
        label="Tariff:"
        value={
          debit?.tariff ? `${debit?.tariff.prefix}${debit?.tariff.code}` : 'N/A'
        }
      />
      <InfoRow label="Fee Submitted:" value={`$${debit.requestedAmount}`} />
      <InfoRow
        label="Overhead:"
        value={`${overhead}% ($${calculateOverheadFee(
          debit.requestedAmount,
          overhead
        )})`}
      />
      <InfoRow
        label="Net Amount:"
        value={`$${calculateNetAmount(debit.requestedAmount, overhead)}`}
      />
    </Card>
  );
};

interface InfoRowProps {
  label: string;
  value: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <Text
    size="sm"
    style={{
      justifyContent: 'space-between',
      width: '100%',
      display: 'flex',
    }}
  >
    {label} <Text>{value}</Text>
  </Text>
);
